import { Component, Prop, Vue } from 'vue-property-decorator';
import appStore from '@/store/app';
import AsideLogo from '@/components/AsideLogo';
import AsideMenuList from '@/components/AsideMenuList';
import { Menu } from '@/models';
import authenticator from '@/store/authentication';
import { authorizedMenus } from '@/filters';

@Component({
    components: { AsideLogo, AsideMenuList },
})
export default class AsideMenu extends Vue {

    @Prop({ default: [] }) private readonly menu!: Menu[];

    private isExpanded = false;

    get isAsideVisible(): boolean {
        return appStore.isAsideVisible;
    }

    get isAsideMobileExpanded(): boolean {
        return appStore.isAsideMobileExpanded;
    }

    get authorizedMenu(): Menu[] {
        return authorizedMenus(authenticator.userProfile, this.menu);
    }

    private async onSelectMenu(menu: Menu) {
        if (menu) {
            await appStore.activateMenu(menu);
        }
    }
}
